import { StateMode, StateModeIdentifier } from './definition.mode';
import { stateControllerPromise } from '../module';

export class State<S, T> {
    private _active: boolean = false;
    protected _domItems: HTMLDivElement[] = [];
    private _modes: StateMode[] = [];

    private _customToggleDomItems: { div: HTMLDivElement, initialDisplay: string | null }[] = [];

    protected _passOverPrameters?: T;
    protected _inputPrameters?: S;

    protected id: StateIdentifier = 'undefined';
    protected _parentContainer: HTMLDivElement;

    get active(): boolean {
        return this._active;
    }
    set active(v: boolean) {
        this._active = v;
        this.setMode('default');
        if (v === true) {
            this.onActivated();
        } else {
            this.onDisactivated();
        }
    }

    public activateAndInit(inputPrameters: S) {
        this._inputPrameters = inputPrameters;
        console.log(this._inputPrameters);
        this.active = true;
    }

    get passOverPrameters(): T | undefined {
        return this._passOverPrameters;
    }

    constructor(parentContainer: HTMLDivElement) {
        this._parentContainer = parentContainer;
        this.addMode('default');
    }

    // post activate function. It is used (via override) to do something after activate (eg change mode when no default mode is needed)
    // notice that on activate default mode is used
    protected onActivated() {

    }

    // post activate function. It is used (via override) to do something after activate (eg change mode when no default mode is needed)
    // notice that on activate default mode is used
    protected onDisactivated() {

    }

    protected createDomItem(
        parent: HTMLDivElement,
        id: string,
        options: {
            className?: string,
            modeDomLink?: StateModeIdentifier[],
            stateItem?: boolean,
            modeToEnable?: StateModeIdentifier,
            stateChange?: { sourceStateId: StateIdentifier, targetStateId: StateIdentifier },
            customToggleDomItem?: {
                initialStatus: boolean
            }
        }) {

        let newDomItem = document.createElement("div");
        newDomItem.id = id;
        if (options.className) {
            newDomItem.className = options.className;
        }
        parent.appendChild(newDomItem);
        if (options.stateItem) {
            this._domItems.push(newDomItem);
        }
        if (options.modeDomLink) {
            options.modeDomLink.forEach(m => {
                this.mode(m).appendDomItem(newDomItem);
            })
        }

        if (options.customToggleDomItem) {
            this._customToggleDomItems.push({ div: newDomItem, initialDisplay: newDomItem.style.display });
            if (options.customToggleDomItem.initialStatus === false) {
                newDomItem.style.display = 'none';
            }
        }

        if (options.modeToEnable) {
            this.attachModeToDomEvent(newDomItem, options.modeToEnable);
        }

        if (options.stateChange !== undefined) {
            // need to ensure stateController has been initialized
            // console.log(stateControllerPromise);
            let op = options.stateChange;
            stateControllerPromise.then(stateController => {
                stateController.attachStateToDomEvent(newDomItem, op.sourceStateId, op.targetStateId);
            });
        }

        return newDomItem;
    }

    protected mode(id: StateModeIdentifier): StateMode {
        let out: StateMode = this._modes[0];
        this._modes.forEach(m => {
            if (m.id === id) {
                out = m;
            }
        });
        return out;
    }

    protected setMode(id: StateModeIdentifier) {
        this._domItems.forEach(d => { d.style.display = 'none'; });
        // console.log('state', this.id);
        // console.log(this._domItems);
        if (this._active) {
            // console.log('state', this.id);
            // console.log(id);
            // console.log(this._modes);
            this._modes.forEach(m => {
                m.active = (m.id === id)
            });
        }
    }

    protected attachModeToDomEvent(dom: HTMLDivElement, modeId: StateModeIdentifier) {
        dom.addEventListener("click", () => {
            this.setMode(modeId);
        });
    }

    protected addMode(modeId: StateModeIdentifier) {
        let m = new StateMode(modeId);
        this._modes.push(m);
        return m;
    }

    public customToggleDomItem(id: string, display: boolean) {
        this._customToggleDomItems.forEach(d => {
            if (d.div.id === id) {
                if (display === true) {
                    d.div.style.display = (d.initialDisplay === null) ? 'block' : d.initialDisplay;
                } else {
                    d.div.style.display = 'none';
                }
            }
        })
    }


    public dispose() {
        this._domItems.forEach(d=>{
            this._parentContainer.removeChild(d);
        })
    }
}



export type StateIdentifier = 'undefined' | 'select-area' | 'select-product' | 'select-dataset' | 'verify-proceed';